export const navBarItems = [
  {
    label: 'cards',
    acf: {
      icon: 'fa-classic fa-solid fa-cards-blank',
    },
    href: '/cards',
  },
  {
    label: 'decks',
    acf: {
      icon: 'fa-classic fa-solid fa-cauldron',
    },
    href: '/decks',
  },
  {
    label: 'market',
    acf: {
      icon: 'fa-classic fa-solid fa-bag-shopping',
    },
    href: '/cards/market',
    hideOnApp: true,
  },
  {
    label: 'pod',
    acf: {
      icon: 'fa-classic fa-solid fa-print',
    },
    href: '/printing',
    hideOnApp: true,
  },
  {
    label: 'events',
    acf: {
      icon: 'fa-classic fa-solid fa-location-dot',
    },
    href: '/event-locator',
  },
];

// Find the first matching item (items are sorted by href length, longest first)
export const sortedItems = [...navBarItems].sort((a, b) => (b.href?.length || 0) - (a.href?.length || 0));

export const loginItem = {
  label: 'sign-in',
  acf: {
    icon: 'fa-classic fa-solid fa-user',
  },
  href: ' /login/',
};

export const scanItem = {
  label: 'scan-cta',
  url: '/multiscan-collection/',
};
